export default function isAuthenticated(auth) {
  return auth && auth.data && auth.data.auth;
}
